export default "__VITE_ASSET__DaA8nB7p__"